<template>
  <div class="container">
    <h1>Доступные марки</h1>

    <!-- search -->
    <div class="d-flex justify-content-center m-3 btn-group">
      <div class="row row-cols-2">
        <div class="col mt-1">
          <input
            v-model="dateFrom"
            type="date"
            class="form-control fs-5"
            placeholder="Дата"
          />
        </div>
        <div class="col mt-1">
          <input
            v-model="dateTo"
            type="date"
            class="form-control fs-5"
            placeholder="Дата"
          />
        </div>
      </div>
    </div>

    <div class="justify-content-center">
      <div class="row">
        <div class="col mt-1">
          <Multiselect
            v-model="product"
            :options="products"
            :loading="false"
            trackBy="name"
            label="name"
            valueProp="guidProduct"
            :internal-search="false"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            noOptionsText="Не найден"
            :limit="10"
            placeholder="Номенклатура"
          >
          </Multiselect>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="row">
        <div class="col mt-3">
          <button class="btn btn-primary" @click="getReportData()">
            ОБНОВИТЬ
            <Spinner v-if="getReportDataSpinner" />
          </button>
        </div>
      </div>
    </div>

    <div class="m-3">
      <div class="row fw-bold">
        <div class="col-4">Марка</div>
        <div class="col-2">Номенклатура</div>
        <div class="col-2">Маршрутный</div>
        <div class="col-2">Статус</div>
      </div>

      <div v-for="mark in reportData" :key="mark._id" class="row border mt-2">
        <div class="col-4">{{ mark.cis }}</div>
        <div class="col-2">
          <span v-if="mark.productObj && 'name' in mark.productObj">
            {{ mark.productObj.name }}
          </span>
        </div>
        <div class="col-2">
          {{ mark.routeSheetObj.docNumber }} от
          {{ dateFormat(mark.routeSheetObj.date) }}
        </div>

        <div class="col-2">
          <button
            v-if="!mark.status"
            class="btn btn-light"
            @click="getMarkInfo(mark)"
          >
            <svg
              v-if="!mark.spinner"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              height="25"
              width="25"
            >
              <path
                d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
              />
            </svg>
            <Spinner v-if="mark.spinner" />
          </button>
          <span v-if="mark.status">{{ mark.status }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import Spinner from "@/components/Spinner.vue";
import Multiselect from "@vueform/multiselect";

export default {
  components: { Spinner, Multiselect },
  setup() {
    const dateFrom = ref("");
    const dateTo = ref("");
    const reportData = ref([]);
    const getReportDataSpinner = ref(false);

    const product = ref("")
    const products = ref([{name: "Вода1", guidProduct: 1}, {name: "Вода2", guidProduct: 2}])
    const {
      dateFormat,
      // settings,
      markInfo,
      marksAvailabel,
      getSettings,
      getProducts,
    } = useCommonMixin();

    const getReportData = async () => {
      getReportDataSpinner.value = true;

      reportData.value = [];

      let dataResp = {
        dateTo: dateTo.value,
        dateFrom: dateFrom.value,
        guidProduct: product.value,
      };

      let resp = await marksAvailabel(dataResp);
      if (resp.status) {
        reportData.value = resp.data;
      }
      getReportDataSpinner.value = false;
    };

    const getMarkInfo = async (mark) => {
      mark.spinner = true;
      let reqData = { cis: mark.cis };
      let markInfoResp = await markInfo(reqData);
      if (markInfoResp && markInfoResp.status) {
        mark.status = markInfoResp.data.status.replace("Статус: ", "");
      }

      if (!markInfoResp || !markInfoResp.status) {
        mark.status = markInfoResp.errorMsg;
      }
      mark.spinner = false;
    };

    onMounted(async () => {
      await getSettings();

      let today = new Date();
      var lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1
      );
      var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
      dateFrom.value = firstDayOfMonth.toISOString().slice(0, 10);
      dateTo.value = lastDayOfMonth.toISOString().slice(0, 10);

      products.value = []
      let productsResp = await getProducts()
      if (productsResp.status) products.value = productsResp.data
    });

    return {
      dateTo,
      dateFrom,
      getReportData,
      reportData,
      dateFormat,
      getMarkInfo,
      getReportDataSpinner,
      product,
      products
    };
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css">
</style>